import { render, staticRenderFns } from "./OrderCount.vue?vue&type=template&id=7645b866&scoped=true"
import script from "./OrderCount.vue?vue&type=script&lang=js"
export * from "./OrderCount.vue?vue&type=script&lang=js"
import style0 from "./OrderCount.vue?vue&type=style&index=0&id=7645b866&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7645b866",
  null
  
)

export default component.exports